import { FALLBACK_ICON } from 'conversations-message-history/constants/sourceIcons';
import { isHelpDeskTicket } from '../help-desk-ticket/isHelpDeskTicket';
import { getDisplaySubjectLine } from '../getDisplaySubjectLine';
import { isThreadListMember } from '../thread-list-member/isThreadListMember';
import { getAttachmentTypes, getGenericChannel, getIsComment, getIsForwardedEmail, getPreview, getVid, getVisitor, getLatestMessageTimestamp, getLatestReceivedTimestamp, getLatestSentTimestamp, getIsLatestMessageADraft } from '../thread-list-member/threadListMemberGetters';
import { isInboxThreadListMember } from './isInboxViewMember';
import { getAssociatedContact, getAssociatedVid, getSource, getAssociatedAttachments, getIsForwarded, getTextPreview, getLatestMessageAccess } from './viewMemberGetters';
export function getViewMemberProps(viewMember) {
  var _viewMember$subject;
  // Handle HelpDeskTicket first to narrow types for other functions
  if (isHelpDeskTicket(viewMember)) {
    // Create property map from ticket.properties array
    const propertyMap = {};
    viewMember.ticket.properties.forEach(prop => {
      if (prop.name && prop.value !== undefined) {
        propertyMap[prop.name] = prop.value;
      }
    });

    // Extract values using mapping strategy from plan

    // From associations
    const vid = viewMember.associations.contacts[0] || null;
    const associatedContact = null; // No enrichment needed for HelpDeskTicket

    // Direct from metadata
    const preview = viewMember.metadata.text || null;
    const subject = viewMember.metadata.subject || null;
    const isComment = viewMember.metadata.latestMessageThreadComment || false;
    const isLatestMessageADraft = viewMember.metadata.latestMessageADraft || false;
    const latestMessageAccess = viewMember.metadata.latestMessageAccess || null;
    const latestMessageTimestamp = viewMember.metadata.latestMessageTimestamp || null;
    const latestReceivedTimestamp = viewMember.metadata.latestReceivedTimestamp || null;
    const latestSentTimestamp = viewMember.metadata.latestSentTimestamp || null;

    // From property map or metadata
    const genericChannelId = propertyMap['hs_originating_generic_channel_id'] || viewMember.metadata.genericChannelId;
    const source = genericChannelId ? +genericChannelId : null;

    // Computed values
    const noSourceIcon = 'databases';
    const attachmentTypes = viewMember.metadata.hasAttachments ? [] : null;
    const isForwarded = false; // Default value

    return {
      associatedContact,
      vid,
      source,
      preview,
      subject,
      noSourceIcon,
      isComment,
      isLatestMessageADraft,
      latestMessageAccess,
      attachmentTypes,
      isForwarded,
      latestMessageTimestamp,
      latestReceivedTimestamp,
      latestSentTimestamp
    };
  }
  const noSourceIcon = isInboxThreadListMember(viewMember) ? FALLBACK_ICON : 'databases';
  if (isThreadListMember(viewMember)) {
    //TLM props are extracted here still until inbox no longer relies on the type
    const associatedContact = getVisitor(viewMember);
    const vid = getVid(viewMember);
    const source = getGenericChannel(viewMember);
    const preview = getPreview(viewMember);
    const subject = getDisplaySubjectLine(viewMember);
    const isComment = getIsComment(viewMember);
    const isLatestMessageADraft = getIsLatestMessageADraft(viewMember);
    const attachmentTypes = getAttachmentTypes(viewMember);
    const isForwarded = getIsForwardedEmail(viewMember);
    const latestMessageTimestamp = getLatestMessageTimestamp(viewMember);
    const latestReceivedTimestamp = getLatestReceivedTimestamp(viewMember);
    const latestSentTimestamp = getLatestSentTimestamp(viewMember);
    return {
      associatedContact,
      vid,
      source,
      preview,
      subject,
      noSourceIcon,
      isComment,
      isLatestMessageADraft,
      attachmentTypes,
      isForwarded,
      latestMessageTimestamp,
      latestReceivedTimestamp,
      latestSentTimestamp
    };
  }
  const associatedContact = getAssociatedContact(viewMember);
  const vid = getAssociatedVid(viewMember);
  const source = getSource(viewMember);
  const preview = getTextPreview(viewMember);
  const subject = (_viewMember$subject = viewMember.subject) !== null && _viewMember$subject !== void 0 ? _viewMember$subject : null;
  const isComment = viewMember.latestMessageThreadComment;
  const isLatestMessageADraft = viewMember.latestMessageADraft;
  const latestMessageAccess = getLatestMessageAccess(viewMember);
  const attachmentTypes = getAssociatedAttachments(viewMember);
  const isForwarded = getIsForwarded(viewMember);
  const latestMessageTimestamp = viewMember.latestMessageTimestamp;
  const latestReceivedTimestamp = viewMember.latestReceivedTimestamp;
  const latestSentTimestamp = viewMember.latestSentTimestamp;
  return {
    associatedContact,
    vid,
    source,
    preview,
    subject,
    noSourceIcon,
    isComment,
    isLatestMessageADraft,
    latestMessageAccess,
    attachmentTypes,
    isForwarded,
    latestMessageTimestamp,
    latestReceivedTimestamp,
    latestSentTimestamp
  };
}